class PartyGoer{
    constructor(firstName, lastName, email, partyId, isAdmin){
        this.firstName = firstName;
        this.lastName = lastName;
        this.email = email;
        this.partyId = partyId;
        this.isAdmin = isAdmin;
    }
}

export default PartyGoer;